import { createElement, useCallback, useState, useMemo, useEffect } from 'react';
import './good-item.scss';
import subtractPng from '../../../assets/icon/shop/subtract.png';
import addPng from '../../../assets/icon/shop/add.png';
import checkboxPng from '../../../assets/icon/shop/checkbox.png';
const GoodItem = ({ item, isEdit, onUpdateItem, onCheckChange, onAddOrSubtract, ...otherProps }) => {
    const _otherProps = otherProps || {};
    const [localItem, setLocalItem] = useState(item);
    useEffect(() => {
        console.log('修改', localItem.id, localItem.checked);
    }, [item.checked]);
    const isUndercarriage = useMemo(() => {
        return localItem.productGrounding === '已下架' || localItem.productGrounding === '1';
    }, [localItem]);
    const handleSubtract = useCallback(() => {
        if (localItem.amount <= 1)
            return;
        const prevItem = { ...localItem, amount: localItem.amount - 1, isUpdate: true };
        setLocalItem(prevItem);
        onUpdateItem({ ...localItem, amount: localItem.amount - 1, isUpdate: true });
        onAddOrSubtract('subtract', prevItem);
    }, [localItem, onUpdateItem]);
    const handleAdd = useCallback(() => {
        const prevItem = { ...localItem, amount: localItem.amount + 1, isUpdate: true };
        setLocalItem(prevItem);
        onUpdateItem(prevItem);
        onAddOrSubtract('add', prevItem);
    }, [localItem, onUpdateItem]);
    const handleCheckChange = useCallback(() => {
        const prevItem = { ...localItem, checked: !localItem.checked };
        setLocalItem(prevItem);
        onCheckChange(prevItem);
    }, [onCheckChange]);
    return (createElement("div", { className: "view", ..._otherProps },
        createElement("div", { className: "left" },
            item.checked ? (createElement("div", { className: "checkbox-img" },
                createElement("img", { className: "checkbox-img", src: checkboxPng, onClick: handleCheckChange }))) : (createElement("div", { className: "checkbox2", onClick: handleCheckChange })),
            createElement("div", { className: "cover-box" },
                isUndercarriage && createElement("div", { className: "overlay" },
                    createElement("span", null, "\u5DF2\u4E0B\u67B6")),
                createElement("img", { className: "cover", src: localItem.imgUrl, alt: "cover", style: { objectFit: 'cover' } }))),
        createElement("div", { className: "info" },
            createElement("div", { className: "title" }, localItem.productName),
            createElement("div", { className: "good-item-footer" },
                createElement("div", { className: "price" },
                    "\u00A5",
                    createElement("span", null, localItem.productPromotionPrice || localItem.productPrice),
                    localItem.productPromotionPrice && (createElement("span", { className: "line-through" },
                        "\u00A5",
                        localItem.productPrice))),
                !isUndercarriage && (createElement("div", { className: "actions" },
                    createElement("div", { className: "subtract", onClick: handleSubtract },
                        createElement("img", { className: "icon", src: subtractPng, alt: "subtract" })),
                    createElement("div", { className: "text" }, localItem.amount),
                    createElement("div", { className: "add", onClick: handleAdd },
                        createElement("img", { className: "icon", src: addPng, alt: "add" }))))))));
};
GoodItem.displayName = 'GoodItem';
export default GoodItem;
